import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <main className="min-h-screen bg-stone-50 dark:bg-stone-950 text-stone-900 dark:text-stone-100 flex items-center justify-center pt-14">
      <div className="text-center">
        <p className="text-6xl mb-6">🍽</p>
        <h1 className="text-4xl font-bold mb-3">404</h1>
        <p className="text-stone-500 dark:text-stone-400 mb-8">
          This seat is empty.
        </p>
        <Link
          to="/"
          className="text-amber-500 hover:text-amber-400 transition-colors text-sm"
        >
          ← Back to the table
        </Link>
      </div>
    </main>
  );
}
